// Get the current user's ID from localStorage
export const getCurrentUserId = () => {
  return localStorage.getItem('userid');
};

// Get all user data from localStorage
export const getCurrentUserData = () => {
  return {
    userid: localStorage.getItem('userid'),
    username: localStorage.getItem('username'),
    access_token: localStorage.getItem('access_token'),
  };
};
